import React from 'react';

const ReportsPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/reports',
			exact: true,
			component: React.lazy(() => import('./ReportsPage')),
		},
	],
};

export default ReportsPageConfig;
